import { HttpClient } from '@angular/common/http';
import { ChangeRequest } from '@models/change-requests/change-request.model';
import { Injectable } from '@angular/core';

@Injectable()
export class ChangeRequestService {
    constructor(private http: HttpClient) {}

    async cancel(changeRequest: ChangeRequest): Promise<void> {
        const url = `/v2/changeRequest/changeRequests/${changeRequest.id}/cancel`;
        await this.http.post(url, {}).toPromise();
    }
}
